import { atom } from "jotai";

export const previousState = atom(null) as any;
